import { render } from "./TheStoreHeader.vue?vue&type=template&id=a8b2d550&scoped=true"
import script from "./TheStoreHeader.vue?vue&type=script&lang=js"
export * from "./TheStoreHeader.vue?vue&type=script&lang=js"

import "./TheStoreHeader.vue?vue&type=style&index=0&id=a8b2d550&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a8b2d550"

export default script